import { ActionAny, createActions } from 'src/utils/createActions';
import { DemoPageData } from 'src/react/demoPage/state/DemoPageState';
import { DemoFilterParams } from 'src/react/demoPage/state/DemoFilterParams';

export type DemoFilterActions =
    ActionAny<DemoFilterParams, DemoPageData>;
export const DEMO_FILTER_ACTIONS =
    createActions<DemoFilterParams, DemoPageData>('DEMO_FILTER');
